var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumberList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33301 11.8326C5.33301 11.5565 5.55687 11.3326 5.83301 11.3326H14.833C15.1091 11.3326 15.333 11.5565 15.333 11.8326C15.333 12.1088 15.1091 12.3326 14.833 12.3326H5.83301C5.55687 12.3326 5.33301 12.1088 5.33301 11.8326Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33301 7.83264C5.33301 7.5565 5.55687 7.33264 5.83301 7.33264H14.833C15.1091 7.33264 15.333 7.5565 15.333 7.83264C15.333 8.10878 15.1091 8.33264 14.833 8.33264H5.83301C5.55687 8.33264 5.33301 8.10878 5.33301 7.83264Z",
    fill: "#585858"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33301 3.83264C5.33301 3.5565 5.55687 3.33264 5.83301 3.33264H14.833C15.1091 3.33264 15.333 3.5565 15.333 3.83264C15.333 4.10878 15.1091 4.33264 14.833 4.33264H5.83301C5.55687 4.33264 5.33301 4.10878 5.33301 3.83264Z",
    fill: "#585858"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.0459 12.1979V11.7233H2.33301C2.5498 11.7233 2.69629 11.5865 2.69629 11.4069C2.69629 11.2213 2.53809 11.0963 2.33496 11.0963C2.1123 11.0963 1.96777 11.2487 1.96191 11.4069H1.37207C1.3877 10.9401 1.74512 10.6197 2.3584 10.6197C2.94629 10.6178 3.31152 10.9108 3.31543 11.3229C3.31934 11.7018 3.0127 11.8873 2.82324 11.9166V11.9498C3.07715 11.9733 3.3877 12.1647 3.3916 12.5807C3.39551 13.1139 2.88965 13.3815 2.34082 13.3815C1.68457 13.3815 1.34082 13.0104 1.33301 12.5865H1.91504C1.92285 12.7643 2.10059 12.8932 2.33691 12.8951C2.59082 12.8951 2.76074 12.7506 2.75879 12.5455C2.75684 12.3502 2.60449 12.1979 2.34473 12.1979H2.0459Z",
    fill: "#585858"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04199 7.49866H1.43848V7.4635C1.43848 7.0553 1.7334 6.61975 2.39551 6.61975C2.97949 6.61975 3.35645 6.94592 3.35645 7.37561C3.35645 7.76428 3.09863 7.9928 2.87988 8.22327L2.34277 8.79553V8.82483H3.39746V9.33264H1.47559V8.93811L2.43262 7.94788C2.57129 7.8053 2.72559 7.64319 2.72559 7.44006C2.72559 7.26038 2.5791 7.11975 2.38379 7.11975C2.16895 7.11975 2.04199 7.27991 2.04199 7.45764C2.04199 7.47131 2.04199 7.48889 2.04199 7.49866Z",
    fill: "#585858"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.89668 5.33264H2.26191V3.25647H2.23066L1.63301 3.67639V3.10999L2.26191 2.66663H2.89668V5.33264Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberList);
export default __webpack_public_path__ + "static/media/numberList.ca181d8c53a7a8dd5c98351b03b794cc.svg";
export { ForwardRef as ReactComponent };